import { OrderGroupModel } from './models';

export const state = {
  orderGroup: new OrderGroupModel(),
  currentFulfillmentInfo: null,
};

export const mutations = {

};